import type { Movie } from '@filmsloth/shared';
import type { Translate } from '../i18n/index.js';

/**
 * "2020 · 120 min", or just whichever half is actually known — year and
 * runtime are both optional on a suggested film, so a card must still read
 * fine with either one, or both, missing.
 */
export function movieMeta(movie: Movie, t: Translate): string {
  const parts: string[] = [];
  if (movie.year !== null) parts.push(String(movie.year));
  if (movie.runtimeMinutes !== null) {
    parts.push(t('common.minutes', { count: movie.runtimeMinutes }));
  }
  return parts.join(' · ');
}
